<template>
  <div class="step-container">
    <div class="step-number">{{ stepNumber }}</div>

    <div class="step-card">
      <h3>{{ title }}</h3>
      <p>
        {{ description }}
      </p>

      <ul>
        <li v-for="(item, index) in items" :key="index">{{ item }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepCard",
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.step-container {
  position: relative;
  width: 300px;
  margin: 40px auto;
}

/* Número no topo */
.step-number {
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  background-color: #1f4ba5;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 3rem;
  z-index: 2;
}

/* Card */
.step-card {
  background-color: #ff7a00;
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
  padding-top: 60px;
  min-height: 320px;
}

.step-card h3 {
  color: #fff;
  margin-top: 0;
  font-size: 16px;
  margin-bottom: 10px;
}

.step-card p {
  font-size: 14px;
}

.step-card ul {
  margin-top: 10px;
  padding-left: 18px;
}

.step-card li {
  margin-bottom: 5px;
  font-size: 14px;
}
</style>